<template>
  <p>Registration for VIZBI 2011 has now closed.</p>
</template>
